export default __webpack_public_path__ + "static/media/visa.cf9d4300.svg";